import { useAuth } from '../pages/login/OAuth';

const useInvoiceService = () => {
    const { api } = useAuth();

    const getInvoice = (id) =>
        api().get(`/invoices/${id}`);

    const getInvoices = (params) =>
        api().get('/invoices/', { params });

    const createInvoice = (data) =>
        api().post('/invoices/new', data);

    const updateInvoice = (data) =>
        api().patch('/invoices/', data);

    const payInvoice = (data) =>
        api().patch('/invoices/pay_invoice', data);

    const payRetention = (data) =>
        api().patch('/invoices/pay_retention', data);

    const editRetentionLimitDate = (data) =>
        api().patch('/invoices/edit_retention_limit_date', data);

    const disableInvoice = (id) =>
        api().patch('/invoices/disable', { id });

    const exportInvoices = (params) =>
        api().post('/invoices/export', params, { responseType: 'blob' });

    const exportInvoicesPdf = (data) =>
        api().post('/invoices/export/pdf', data, { responseType: 'blob' });

    const getInvoiceProformPdf = (id) =>
        api().get(`/invoices/${id}/generate-pdf/proform`, { responseType: 'blob' });

    const getInvoicePdf = (id) =>
        api().get(`/invoices/${id}/generate-pdf/invoice`, { responseType: 'blob' });

    const payInvoicesBulk = (data) =>
        api().post('/invoices/pay_bulk', data);

    const getInvoiceDrafts = (params) =>
        api().get('/invoices/drafts', { params });

    const validateInvoiceDraft = (id) =>
        api().post(`/invoices/${id}/validate`);

    const unvalidateInvoiceDraft = (id) =>
        api().delete(`/invoices/${id}/validate`);

    const getInvoiceValidators = () =>
        api().get('/invoice_validators/');

    const addInvoiceValidator = (userId) =>
        api().post('/invoice_validators/', { user_id: userId });

    const removeInvoiceValidator = (userId) =>
        api().delete(`/invoice_validators/${userId}`);

    return {
        getInvoice,
        getInvoices,
        createInvoice,
        updateInvoice,
        payInvoice,
        payRetention,
        editRetentionLimitDate,
        disableInvoice,
        exportInvoices,
        exportInvoicesPdf,
        getInvoiceProformPdf,
        getInvoicePdf,
        payInvoicesBulk,
        getInvoiceDrafts,
        validateInvoiceDraft,
        unvalidateInvoiceDraft,
        getInvoiceValidators,
        addInvoiceValidator,
        removeInvoiceValidator,
    };
};

export default useInvoiceService;
